import AES from 'crypto-js/aes'
import HEX from 'crypto-js/enc-hex'
import UTF8 from 'crypto-js/enc-utf8'
import HmacSHA256 from 'crypto-js/hmac-sha256'
import SHA1 from 'crypto-js/sha1'

export type AesEncryptType = ReturnType<typeof AES.encrypt>

/**
 * SHA-1 해시 알고리즘
 **/
export function makeSHA1Key(key: string): string {
    return SHA1(key).toString()
}

/**
 * AES 알고리즘을 사용하여 데이터 암호화
 **/
export function encryptAes(value: string, key: string): string {
    return AES.encrypt(value, key).toString()
}

/**
 * AES 알고리즘을 사용하여 데이터 복호화
 **/
export function decryptAes(value: string, key: string): string {
    return AES.decrypt(value, key).toString(UTF8)
}

/** 16진수 문자열로 변환하는 함수 */
export function encodeToHex(value: string): string {
    return HEX.stringify(SHA1(value)).toString()
}

/**
 * HMAC sha 256 방식을 사용한 암호문 생성
 * @param {string} key 사용할 암호키
 * @param {string} target 암호화될 문자열
 */
export const getCipher = (key = '', target: string | object) => {
    let plainText
    if (typeof target === 'object') {
        plainText = JSON.stringify(target)
    } else {
        plainText = target
    }

    return HEX.stringify(HmacSHA256(plainText, key))
}
